import { StandardEvents } from '@shopify/events';

// Gift boxes are no longer offered. Remove selections saved in older carts
// so retiring the controls cannot leave a packaging charge behind.
const isRetiredGiftBox = (item) => (
  item.handle === 'mofu-gift-box-packaging'
  || item.properties?.['_Mofu add-on'] === 'Gift box packaging'
);

let cleanupInFlight;

const removeRetiredGiftBoxes = async () => {
  if (cleanupInFlight) return cleanupInFlight;

  cleanupInFlight = (async () => {
    const cartUrl = window.Theme?.routes?.cart_url || '/cart';
    const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not check the cart for retired packaging.');

    const cart = await response.json();
    const lines = (cart.items || [])
      .filter(isRetiredGiftBox)
      .map((item) => ({ id: item.key, quantity: 0 }));

    if (!lines.length) return;

    const result = await window.Shopify.actions.updateCart(
      { lines },
      { event: { context: 'cart', detail: { source: 'mofu-remove-retired-gift-box' } } }
    );
    if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
  })();

  try {
    await cleanupInFlight;
  } finally {
    cleanupInFlight = null;
  }
};

const scheduleCleanup = (attempt = 0) => {
  window.setTimeout(async () => {
    if (!window.Shopify?.actions?.updateCart) {
      if (attempt < 12) scheduleCleanup(attempt + 1);
      return;
    }

    try {
      await removeRetiredGiftBoxes();
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.warn('[mofu-gift-packaging] Could not remove retired packaging:', error);
      }
    }
  }, attempt === 0 ? 200 : 250);
};

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(() => scheduleCleanup()).catch(() => {});
});

scheduleCleanup();
